import { Injectable } from '@angular/core';

@Injectable()
// Share methods between Mobile and Full Web view
export class MenuMoreCommon {
	constructor(
	) {}

}



// WEBPACK FOOTER //
// ./src/modules/menu-more/pages/menu-more/menu-more.common.ts